export const SET_APPRAISER_MODAL = 'SET_APPRAISER_MODAL';
export const SET_DELETE_APPRAISER_MODAL = 'SET_DELETE_APPRAISER_MODAL';
export const SET_RESTORE_APPRAISER_MODAL = 'SET_RESTORE_APPRAISER_MODAL';

export const setAppraiserModal = (state) => (dispatch) => {
    dispatch({ type: SET_APPRAISER_MODAL, state });
};

export const setDeleteAppraiserModal = (state) => (dispatch) => {
    dispatch({ type: SET_DELETE_APPRAISER_MODAL, state });
};

export const setRestoreAppraiserModal = (state) => (dispatch) => {
    dispatch({ type: SET_RESTORE_APPRAISER_MODAL, state });
};

export default {
    SET_APPRAISER_MODAL,
    setAppraiserModal,
    SET_DELETE_APPRAISER_MODAL,
    setDeleteAppraiserModal,
    SET_RESTORE_APPRAISER_MODAL,
    setRestoreAppraiserModal,
};
